module.exports = __webpack_public_path__ + "img/close2.83bf9188.svg";